import { render, staticRenderFns } from "./VgPullRefreshList.vue?vue&type=template&id=3209f231&scoped=true&"
import script from "./VgPullRefreshList.vue?vue&type=script&lang=js&"
export * from "./VgPullRefreshList.vue?vue&type=script&lang=js&"
import style0 from "./VgPullRefreshList.vue?vue&type=style&index=0&id=3209f231&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3209f231",
  null
  
)

export default component.exports